import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Common } from '@trimblemaps/trimblemaps-js';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { COUNTRIES, Country } from 'src/app/utils/countries';
import { STATES } from 'src/app/utils/states';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { CurrencyState } from 'src/app/_models/state/optionUIState';
import { RouteState } from 'src/app/_models/state/routeState';
import {
  MileageReportReportLineView,
  StateReportReportLineView,
} from '../../_models/view/stateCountryReportView';
@Component({
  selector: 'app-state-country-distance-report',
  templateUrl: './state-country-distance-report.component.html',
  styleUrls: ['./state-country-distance-report.component.scss'],
})
export class StateCountryDistanceReportComponent implements OnInit, OnDestroy {
  @Input() route: RouteState;
  @Input() displayCurrency: CurrencyState;
  @Input() isStandardUser: boolean;
  @Input() printView: boolean;
  @Input() distanceUnits: number;
  @Input() precision: number;
  countries: Country = COUNTRIES;
  mileageReportLines: MileageReportReportLineView[] = [];
  mileageStopsCount: number;
  stateReportLines: StateReportReportLineView[];
  private subscriptionManager = new SubscriptionManager();
  isEuRegion: boolean;
  hasTolls = false;
  hasTTolls = false;
  hasLTolls = false;
  constructor(private authenticationService: AuthenticationService) {}

  ngOnInit(): void {
    this.subscriptionManager.manage =
      this.authenticationService.currentUser.subscribe((userInfo) => {
        this.isEuRegion = userInfo?.region.toLowerCase() === Common.Region.EU;
      });

    this.stateReportLines = this.route?.stateCountryReport.StateReportLines.map(
      (rl) => {
        return { ...rl };
      }
    );

    this.hasTolls = this.stateReportLines.some(
      (reportLine) => reportLine.Tolls !== null
    );

    if (!this.isEuRegion) {
      this.stateReportLines.forEach((data) => {
        data.isCountry = this.countries?.NA.some((country) =>
          country.abbreviation === data.StCntry
            ? !STATES.some((state) => data.StCntry === state.abbreviation)
            : country.name === data.StCntry
        );
      });
    }

    this.mileageStopsCount =
      this.route?.stateCountryReport?.MileageReportLines?.length;
    this.mileageReportLines =
      this.route?.stateCountryReport?.MileageReportLines.map((mrl) => {
        return { ...mrl };
      });

    this.hasLTolls = this.mileageReportLines.some(
      (reportLine) => reportLine.LTolls !== null
    );
    this.hasTTolls = this.mileageReportLines.some(
      (reportLine) => reportLine.TTolls !== null
    );

    if (this.mileageReportLines.length) {
      let i = 0;
      this.mileageReportLines.forEach((mrl, index) => {
        if (mrl.Stop) {
          mrl.routeAddress = this.route.stopsState[i];
          i++;
          const addressDetails = [
            mrl.Stop?.Address?.StreetAddress,
            mrl.Stop?.Address?.City,
            mrl.Stop?.Address?.Zip,
            mrl.Stop?.Address?.State,
            mrl.Stop?.Address?.County,
          ]
            .filter(Boolean)
            .join();
          if (index === 0) {
            mrl.StopDisplay = `Origin: ${addressDetails}`;
          } else if (index === this.mileageStopsCount - 1) {
            mrl.StopDisplay = `Dest: ${addressDetails}`;
          } else {
            mrl.StopDisplay = `Stop ${index}: ${addressDetails}`;
          }
        }
      });
    }
  }
  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe();
  }
}
